import React, {Fragment, Suspense} from 'react';
import {Stack, Typography, Divider} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {
	PlanField,
	CellPhoneField,
	EmailField,
	AddressSection,
	ChangePasswordField,
	SignOutField,
	BeneficiaryCard,
	DataAccordion,
	AddressLoading,
	FacialBiometricsField,
	FacialBiometricAlreadyRegisteredModal,
} from 'presentation/pages/private/profile/components';
import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';
import BusinessToggle from '../components/BusinessToggle';
import {CustomBox} from './styles';
import {Bank} from 'presentation/components/ChangeData/Bank';
import {AccordionStateEnum} from '../store/formAccordionStore/types';
import {useProfilePage} from '../hooks/useProfilePage';
import {useAccountInformation, useChangeDataProfile} from '../../hooks';
import {useFacialBiometricFeatureFlag} from '../../hooks/useFacialBiometricFeatureFlag';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';

export function ProfileContentLegacy() {
	const {isResponsibleWithoutBenefits, canChangePassword, canChangeAddress} =
		useAccountInformation();

	const {handleChangeDataFocus, changeDataFormState, handleChangeDataFormOpen} =
		useChangeDataProfile();

	const hasFacialBiometrics = useFacialBiometricsStore(store => store.hasFacialBiometrics);

	const {
		isLaptop,
		showBankData,
		showB2BToggle,
		isAlreadyRegisteredModalOpen,
		setIsAlreadyRegisteredModalOpen,
	} = useProfilePage();

	const {isEnabled: isFacialBiometricEnabled} = useFacialBiometricFeatureFlag();

	return (
		<>
			<StyledGrid.Root>
				<StyledGrid.Item sm={12} md={12} lg={8}>
					<Stack spacing={2}>
						{isLaptop ? (
							<BeneficiaryCard
								isResponsibleWithoutBenefits={isResponsibleWithoutBenefits}
							/>
						) : null}

						<PlanField />

						<CustomBox>
							<Typography variant="subtitle2">Celular</Typography>
							<Suspense fallback={<SkeletonData type="cellPhone" />}>
								<CellPhoneField />
							</Suspense>
						</CustomBox>

						<CustomBox>
							<Typography variant="subtitle2">Email</Typography>
							<Suspense fallback={<SkeletonData type="email" />}>
								<EmailField />
							</Suspense>
						</CustomBox>

						{canChangeAddress ? (
							<Suspense fallback={<AddressLoading />}>
								<AddressSection />
							</Suspense>
						) : null}

						{showBankData ? (
							<Fragment>
								<DataAccordion
									expanded={changeDataFormState.name === AccordionStateEnum.BANK}
									handleChangeExpanded={() =>
										handleChangeDataFocus(AccordionStateEnum.BANK)
									}
									title="Banco"
									icon="account-balance-wallet-filled">
									<Bank
										hiddenTitle
										onEmptyAction={handleChangeDataFormOpen}
										handleChangeForm={handleChangeDataFormOpen}
										showForm={changeDataFormState.isFormActive}
									/>
								</DataAccordion>

								<Divider />
							</Fragment>
						) : null}

						{showB2BToggle ? <BusinessToggle /> : null}
						{isFacialBiometricEnabled && !hasFacialBiometrics && (
							<FacialBiometricsField />
						)}
						{canChangePassword ? <ChangePasswordField /> : null}
						<SignOutField />
					</Stack>
				</StyledGrid.Item>
				{!isLaptop ? (
					<StyledGrid.Item sm={12} md={12} lg={4}>
						<BeneficiaryCard
							isResponsibleWithoutBenefits={isResponsibleWithoutBenefits}
						/>
					</StyledGrid.Item>
				) : null}
			</StyledGrid.Root>

			<FacialBiometricAlreadyRegisteredModal
				open={isAlreadyRegisteredModalOpen}
				onClose={() => setIsAlreadyRegisteredModalOpen(false)}
			/>
		</>
	);
}
